import React from 'react';
import Component from '@vfuk/core-small-button';
const SmallButton = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default SmallButton;
